import template   from './country-of-residence.html'
import controller from './country-of-residence.controller'
import './country-of-residence.styl'

let component = {
  restrict: 'E',
  bindings: {
    codeCountry: '=',
    disabled: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/country-of-residence/country-of-residence.component.js